module.exports = __webpack_public_path__ + "static/media/Caminos_logo_blanco.9c656f98.png";